;var analyticsHelper = (function() {
  var CAMPAIGN_TRACKING_ID = 'campaign';
  var TIME_30_MIN = 1800000;
  var cookieDomain = window.location.hostname.indexOf('ring.com') < 0? window.location.hostname: '.ring.com';

  function getCookie(name){
    var match = document.cookie.match(new RegExp(name + '=([^;]*)?(;|$)', 'im'));
    return (match && decodeURIComponent(match[1])) || false;
  }

  function getQueryParam(name){
    var match = window.location.search.match(new RegExp(name + '=(.*?)(&|$|#|\\?)', 'im'));
    return (match && decodeURIComponent(match[1])) || '';
  }

  function initCampaignTracking(){
    setCampaignData(getCampaignData() || {
      data: {
        utm_source: getQueryParam('utm_source'),
        utm_medium: getQueryParam('utm_medium'),
        utm_campaign: getQueryParam('utm_campaign'),
        utm_content: getQueryParam('utm_content'),
        utm_term: getQueryParam('utm_term'),
        referrer: document.referrer,
        path: document.location.pathname
      }
    });
  }

  function applyCampaignTracking(props){
    var campaignData = getCampaignData();
    if(campaignData){
      if(props.session_properties){
        assign(props.session_properties, campaignData.data);
      }
    }
  }

  function getCampaignData(){
    var cookie = getCookie(CAMPAIGN_TRACKING_ID);
    return (cookie && JSON.parse(cookie)) || undefined;
  }

  function setCampaignData(data){
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + TIME_30_MIN);
    document.cookie = CAMPAIGN_TRACKING_ID + '=' + encodeURIComponent(JSON.stringify(data)) + 
      ';domain=' + cookieDomain + ';path=/;expires=' + expirationDate.toUTCString();
  }

  function assign(obj1, obj2) {
    for(var key in obj2) {
      obj1[key] = obj2[key];
    }
    return obj1;
  }

  var loaded = document.readyState !== 'loading';
  if(loaded){
    initCampaignTracking();
  } else {
    document.addEventListener('DOMContentLoaded', initCampaignTracking);
  }

  return {
    applyCampaignTracking: applyCampaignTracking
  }
})();